import { render } from "./BaseChat.vue?vue&type=template&id=5abda05b"
import script from "./BaseChat.vue?vue&type=script&lang=js"
export * from "./BaseChat.vue?vue&type=script&lang=js"

import "./BaseChat.vue?vue&type=style&index=0&id=5abda05b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__